import { types } from "../action-types";

const initialState = {
  loading: false,
  invitedCandidates: [],
  totalCounts: null,
  error: false,
};

const invitedCandidatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_INVITED_CANDIDATES:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_INVITED_CANDIDATES_SUCCESS:
      return {
        ...state,
        loading: false,
        invitedCandidates: action.payload?.invitedTalents,
        totalCounts: action.payload?.totalCount,
        error: false,
      };
    case types.FETCH_INVITED_CANDIDATES_FAILURE:
      return {
        ...state,
        loading: false,
        invitedCandidates: [],
        totalCounts: null,
        error: true,
      };
      
    default:
      return state;
  }
};

export default invitedCandidatesReducer;
